<template>
  <nav
    id="navigation"
    class="navbar navbar-expand-md navbar-light bg-light p-0"
  >
    <RouterLink
      class="navbar-brand ml-3"
      to="/"
    >
      {{ $t('SOOR BAKALIM') }}
    </RouterLink>
    <button
      class="navbar-toggler navbar-toggler-right m-3"
      type="button"
      data-toggle="collapse"
      data-target="#navbar"
      aria-controls="navbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <div
      id="navbar"
      class="collapse navbar-collapse"
    >
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <RouterLink
            class="nav-link text-light p-3"
            active-class="text-dark"
            to="/"
            exact
          >
            {{ $t('routes.home') }}
          </RouterLink>
        </li>

        <li
          v-if="jwtToken"
          class="nav-item"
        >
          <div class="btn-group">
            <a
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="nav-link bg-dark text-light p-3 dropdown-toggle"
              style="cursor: pointer"
            >
              Admin
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              style="margin-top: -1px"
            >
              <RouterLink
                class="dropdown-item"
                to="/admin/tests"
              >
                Testler
              </RouterLink>
              <RouterLink
                class="dropdown-item"
                to="/admin/typeforms"
              >
                Typeform
              </RouterLink>
              <RouterLink
                class="dropdown-item"
                to="/admin/languages"
              >
                Diller
              </RouterLink>
              <div class="dropdown-divider" />
              <a
                class="dropdown-item"
                style="cursor: pointer"

                @click.stop="logout"
              >
                Çıkış Yap
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    runningEnvironment: process.env.NODE_ENV,
  }),
  computed: {
    ...mapGetters(['jwtToken', 'domainWithoutDot']),
  },
  methods: {
    ...mapMutations(['removeJwtToken']),
    logout() {
      this.removeJwtToken();
      this.$router.push('/');
    },
  },
};
</script>
<style scoped>
  #navigation .nav-item:nth-child(1) {
    background-color: #71a7ea;
  }

  #navigation .nav-item:nth-child(2) {
    background-color: #b8d3f5;
  }

  #navigation .nav-item:nth-child(3) {
    background-color: #71a7ea;
  }
</style>
